import { Popover as BasePopover } from "@base-ui/react/popover";

import type { DatePickerBackdropProps } from "./DatePicker.types";

export function DatePickerBackdrop({ ...props }: DatePickerBackdropProps) {
  return <BasePopover.Backdrop data-slot="date-picker-backdrop" {...props} />;
}
